<!--
 * @Descripttion: 
 * @version: 0.1
 * @Author: luoxi
 * @Date: 
 * @LastEditors: wanglong
 * @LastEditTime: 2021-07-12 10:37:19
 -->
<template>
  <ul class="part2">
    <div class="title">联系人信息 Contact person</div>
    <li>
      <div class="radiobox">
        <el-radio
          v-model="contact.contactSex"
          label="0"
          :disabled="stateCode == 6 || stateCode == 0 ? false : true"
          >先生</el-radio
        >
        <el-radio
          v-model="contact.contactSex"
          label="1"
          :disabled="stateCode == 6 || stateCode == 0 ? false : true"
          >女士</el-radio
        >
        <el-radio
          v-model="contact.contactSex"
          label="2"
          :disabled="stateCode == 6 || stateCode == 0 ? false : true"
          >夫人</el-radio
        >
      </div>
      <el-input
        placeholder="请输入内容"
        v-model="contact.contactFirstNameCh"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">联系人名称：</template>
      </el-input>
      <el-input
        placeholder="请输入内容"
        v-model="contact.contactLastNameCh"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">联系人姓氏：</template>
      </el-input>
    </li>
    <li>
      <div class="radiobox">
        <el-radio
          v-model="contact.contactSex"
          label="0"
          :disabled="stateCode == 6 || stateCode == 0 ? false : true"
          >Mr.</el-radio
        >
        <el-radio
          v-model="contact.contactSex"
          label="1"
          :disabled="stateCode == 6 || stateCode == 0 ? false : true"
          >Ms.</el-radio
        >
        <el-radio
          v-model="contact.contactSex"
          label="2"
          :disabled="stateCode == 6 || stateCode == 0 ? false : true"
          >Mrs.</el-radio
        >
      </div>
      <el-input
        placeholder="请输入内容"
        v-model="contact.contactFirstNameEn"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">First name：</template>
      </el-input>
      <el-input
        placeholder="请输入内容"
        v-model="contact.contactLastNameEn"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">Last name：</template>
      </el-input>
    </li>
    <li>
      <el-input
        style="width: 61%"
        placeholder="请输入内容"
        v-model="contact.contactStreetCh"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">联系人通讯地址：</template>
      </el-input>
      <el-input
        placeholder="请输入内容"
        v-model="contact.contactCityCh"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">城市：</template>
      </el-input>
      <el-input
        placeholder="请输入内容"
        v-model="contact.contactZipCh"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">州/省 邮政编码：</template>
      </el-input>
    </li>
    <li>
      <el-input
        style="width: 61%"
        placeholder="请输入内容"
        v-model="contact.contactStreetEn"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">Street：</template>
      </el-input>
      <el-input
        placeholder="请输入内容"
        v-model="contact.contactCityEn"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">City:</template>
      </el-input>
      <el-input
        placeholder="请输入内容"
        v-model="contact.contactZipEn"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">State/Province & Zip Code：</template>
      </el-input>
    </li>
    <li>
      <el-input
        placeholder="（国家代码-城市区号-电话号码）"
        v-model="contact.contactPhoneCh"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">电话：</template>
      </el-input>
      <el-input
        placeholder="请输入内容"
        v-model="contact.contactFaxCh"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">传真：</template>
      </el-input>
      <el-input
        placeholder="请输入内容"
        v-model="contact.contactEmailCh"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">电子邮箱：</template>
      </el-input>
    </li>
    <li>
      <el-input
        placeholder="Country code / area code / number"
        v-model="contact.contactPhoneEn"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">Phone：</template>
      </el-input>
      <el-input
        placeholder="请输入内容"
        v-model="contact.contactFaxEn"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">Fax：</template>
      </el-input>
      <el-input
        placeholder="请输入内容"
        v-model="contact.contactEmailEn"
        :disabled="stateCode == 6 || stateCode == 0 ? false : true"
      >
        <template slot="prepend">E-mail：</template>
      </el-input>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    Contactpersonh: {
      type: Object,
      default() {
        return {
          type: 0,
          data: null,
        };
      },
    },
    stateCode: {
      type: Number,
      default() {
        return 0;
      },
    },
  },

  components: {},
  computed: {},
  data() {
    return {
      contact: {
        contactSex: "1", //联系人性别
        contactFirstNameCh: "", //联系人 名字
        contactFirstNameEn: "",
        contactLastNameCh: "", //联系人 姓氏
        contactLastNameEn: "",
        contactStreetCh: "", //联系人通讯地址
        contactStreetEn: "",
        contactCityCh: "", //城市
        contactCityEn: "",
        contactZipCh: "", //州/省 邮政编码
        contactZipEn: "", //州/省 邮政编码
        contactPhoneCh: "", //联系人电话
        contactPhoneEn: "",
        contactFaxCh: "", //传真
        contactFaxEn: "",
        contactEmailCh: "", //联系人电子邮箱
        contactEmailEn: "",
      },
    };
  },

  created() {},
  mounted() {
    this.getdetails();
  },
  methods: {
    getdetails() {
      this.contact.contactSex = this.Contactpersonh.contactSex
        ? this.Contactpersonh.contactSex.toString()
        : "";
      this.contact.contactFirstNameCh = this.Contactpersonh.contactFirstNameCh;
      this.contact.contactFirstNameEn = this.Contactpersonh.contactFirstNameEn;
      this.contact.contactLastNameCh = this.Contactpersonh.contactLastNameCh;
      this.contact.contactLastNameEn = this.Contactpersonh.contactLastNameEn;
      this.contact.contactStreetCh = this.Contactpersonh.contactStreetCh;
      this.contact.contactStreetEn = this.Contactpersonh.contactStreetEn;
      this.contact.contactCityCh = this.Contactpersonh.contactCityCh;
      this.contact.contactCityEn = this.Contactpersonh.contactCityEn;
      this.contact.contactZipCh = this.Contactpersonh.contactZipCh;
      this.contact.contactZipEn = this.Contactpersonh.contactZipEn;
      this.contact.contactPhoneCh = this.Contactpersonh.contactPhoneCh;
      this.contact.contactPhoneEn = this.Contactpersonh.contactPhoneEn;
      this.contact.contactFaxCh = this.Contactpersonh.contactFaxCh;
      this.contact.contactFaxEn = this.Contactpersonh.contactFaxEn;
      this.contact.contactEmailCh = this.Contactpersonh.contactEmailCh;
      this.contact.contactEmailEn = this.Contactpersonh.contactEmailEn;
    },
  },
};
</script>

<style scoped="" lang="scss">
.part2 {
  .title {
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #3c4353;
    margin: 48px 100px;
  }

  li {
    display: flex;
    padding-left: 100px;
    padding-right: 100px;
    margin-top: 20px;
    div {
      width: 35%;
    }
    /deep/ .el-input-group {
      // width: 38%;
    }
    /deep/ .el-input-group__prepend {
      border-right: 0;
      color: rgba(36, 85, 139, 1);
      background: white;
      padding-right: 0;
    }
    /deep/ .el-input__inner {
      border-left: 0;
      padding-left: 0;
      &:focus {
        border-color: #dcdfe6;
        outline: 0;
      }
    }

    .radiobox {
      // width: 300px;
      border: 1px solid gainsboro;
      // display: flex;
      .el-radio {
        // margin-left: 30px;
        margin-top: 14px;
        margin-right: 0;
        padding: 0 15px;
        /deep/ .el-radio__label {
          color: #24558b;
        }
      }
    }
  }
  .three {
    .el-input-group {
      width: 29.5%;
    }
    div {
      // width: 30.5% !important;
    }
  }
  .three1 {
    .el-input-group {
      width: 33%;
    }
    div {
      // width: 30.5% !important;
    }
  }
  .two {
    .el-input-group--prepend {
      &:last-of-type {
        width: 50%;
      }
    }
  }

  li:nth-of-type(3) {
    margin-top: 30px;
  }

  li:nth-of-type(5) {
    margin-top: 30px;
  }
}
</style>
